import React from 'react';

const AdminOrders = () => (
  <div style={{ padding:'1rem' }}>
    <h1 style={{ marginTop:0 }}>Orders Dashboard</h1>
    <p>Platform-wide order monitoring, fulfillment status, and escalation tools coming soon.</p>
  </div>
);

export default AdminOrders;
